import { getFullRouteName } from '@/components/settings/subscription/helpers'
import trialMode from '@/router/guards/trial-mode.ts'

import {
  ACCESS_LEVELS,
  PAYMENT_SOURCES,
} from '@/lib/consts.ts'
import { __t } from '@/lib/helpers'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'

const COMPONENTS = {
  'your-subscription': [
    import('@/views/business/settings/subscription/your-subscription.vue'),
    import('@/views/business/settings/subscription/your-subscription-mobile.vue'),
  ],

  'billing-details': [
    import('@/views/business/settings/subscription/billing-details/index.vue'),
    import('@/views/business/settings/subscription/billing-details/index-mobile.vue'),
  ],

  'billing-details.your-billing': [
    import('@/views/business/settings/subscription/billing-details/your-billing/index.vue'),
    import('@/views/business/settings/subscription/billing-details/your-billing/index-mobile.vue'),
  ],

  'billing-details.invoice-details': [
    import('@/views/business/settings/subscription/billing-details/invoice-details.vue'),
    import('@/views/business/settings/subscription/billing-details/invoice-details-mobile.vue'),
  ],

  'payment-method': [
    import('@/views/business/settings/subscription/payment-method/index.vue'),
    import('@/views/business/settings/subscription/payment-method/index-mobile.vue'),
  ],

  'payment-method-add': [
    import('@/views/business/settings/subscription/payment-method/payment-method-change.vue'),
    import('@/views/business/settings/subscription/payment-method/payment-method-change-mobile.vue'),
  ],

  'payment-method-change': [
    import('@/views/business/settings/subscription/payment-method/payment-method-change.vue'),
    import('@/views/business/settings/subscription/payment-method/payment-method-change-mobile.vue'),
  ],
}

export const getSubRoutes = ({ mobile = false } = {}) => {
  const getRouteData = (routeName) => {
    return {
      name: getFullRouteName(routeName, mobile),
      component: () => COMPONENTS[routeName][mobile ? 1 : 0],
    }
  }

  return [
    {
      ...getRouteData('your-subscription'),
      path: 'your-subscription/:subview?',
      meta: {
        title: __t('routes.settings.subscription.your-subscription.title'),
        subtitle: __t('routes.settings.subscription.your-subscription.subtitle'),
      },
    },
    {
      ...getRouteData('billing-details'),
      path: 'billing-details',
      meta: {
        title: __t('routes.settings.subscription.billing-details.title'),
        subtitle: __t('routes.settings.subscription.billing-details.subtitle'),
      },
      children: [
        {
          ...getRouteData('billing-details.your-billing'),
          path: 'your-billing/:tabView?/:subView?',
          meta: {
            title: __t('routes.settings.subscription.billing-details.your-next-payment.title'),
            [ROUTE_META_PARAMS.SEARCH_KEYWORDS]: (store) => {
              const isOverdueViewAvailable = store.getters['business/business'].payment_source !== PAYMENT_SOURCES.OFFLINE
              const isRouteAvailable = store.getters['subscription/isRouteAvailable']

              return [
                {
                  keyword: __t('components.subscription.next-payment.tab-next-payment'),
                  route: 'billing-details.your-billing.next-payment',
                },
                isOverdueViewAvailable && {
                  keyword: __t('components.subscription.overdue-payments.title'),
                  route: 'billing-details.your-billing.overdue-payments',
                },
                {
                  keyword: __t('components.subscription.next-payment.tab-payment-history'),
                  route: 'billing-details.your-billing.billing-history',
                },
              ].filter(tab => tab && isRouteAvailable(tab.route)).map(tab => tab.keyword)
            },
          },
        },

        {
          ...getRouteData('billing-details.invoice-details'),
          path: 'invoice-details',
          meta: {
            title: __t('routes.settings.subscription.billing-details.invoice-details.title'),
          },
        },
      ],
    },
    {
      ...getRouteData('payment-method'),
      path: 'payment-method',
      meta: {
        title: __t('routes.settings.subscription.payment-method.title'),
        subtitle: mobile
          ? __t('components.subscription.payment-details.info')
          : __t('routes.settings.subscription.payment-method.subtitle'),
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          return store.getters['subscription/isRouteAvailable']('payment-method')
        },
      },
    },
    {
      ...getRouteData('payment-method-add'),
      path: 'payment-method/add',
      meta: {
        title: __t('routes.settings.subscription.payment-method.add.title'),
        hidden: true,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,
      },
    },
    {
      ...getRouteData('payment-method-change'),
      path: 'payment-method/change',
      meta: {
        title: __t('routes.settings.subscription.payment-method.change.title'),
        hidden: true,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,
      },
    },
  ]
}

export default [{
  path: 'billing',
  alias: 'billing-mobile',
  name: 'settings.subscription',
  meta: {
    title: __t('routes.settings.subscription.title'),
    subtitle: __t('routes.settings.subscription.subtitle'),
    icon: 'subscription-billing',
    backgroundIcon: 'subscription',
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    mobile: true,
    useSmartlook: true,
  },
  component: () => import('@/views/business/settings/subscription/index.vue'),
  children: getSubRoutes(),
  beforeEnter: trialMode(),
},
{
  path: 'payment-method/info/:type',
  name: getFullRouteName('payment-method-info', false),
  meta: {
    title: __t('routes.settings.subscription.billing-details.title'),
    hidden: true,
    [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,

  },
  component: () => import('@/views/business/settings/subscription/payment-method/payment-method-info.vue'),
  beforeEnter: trialMode(),
},
]
